import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AiChatWidget } from '../ai/AiChatWidget';
import { useAuthStore } from '../../store/authStore';
import './shell.css';

function routeTitle(path: string) {
  if (path === '/campaigns/new') return 'Create campaign';
  if (/^\/campaigns\/.+/.test(path)) return 'Campaign results';
  if (/^\/assessments\/.+/.test(path)) return 'Assessment evidence';
  const names: Record<string, string> = { '/': 'Overview', '/campaigns': 'Campaigns', '/templates': 'Email templates', '/reported-messages': 'Reported messages', '/assessments': 'Assessments', '/analytics/comparison': 'Comparison analytics', '/groups': 'Users & groups', '/pages': 'Landing pages', '/sending-profiles': 'Sending profiles', '/settings': 'Settings', '/analytics/at-risk': 'At-risk recipients', '/analytics/reports': 'Reports', '/suppressions': 'Suppressions', '/deliverability': 'Deliverability', '/platform': 'Platform settings', '/webhooks': 'Webhooks', '/scenarios': 'Scenarios', '/sending_profiles': 'Sending profiles', '/landing_pages': 'Landing pages' };
  return names[path] || 'Workspace';
}
export function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const drawer = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const mustChangePassword = useAuthStore((state) => state.user?.password_change_required);
  useEffect(() => {
    if (!mobileOpen) return;
    const previous = document.activeElement as HTMLElement | null;
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const getFocusable = () => Array.from(drawer.current?.querySelectorAll<HTMLElement>('a, button') || []).filter(el => el.getClientRects().length > 0);
    getFocusable()[0]?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMobileOpen(false);
      if (event.key === 'Tab') {
        const items = getFocusable();
        const first = items[0]; const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    return () => { document.body.style.overflow = oldOverflow; document.removeEventListener('keydown', onKey); previous?.focus(); };
  }, [mobileOpen]);
  return (
    <div className={`app-shell ${collapsed ? 'sidebar-is-collapsed' : ''}`}>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <div className="desktop-sidebar"><Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} /></div>
      {mobileOpen && <div className="mobile-navigation"><div className="navigation-backdrop" onClick={() => setMobileOpen(false)} /><div id="app-navigation" ref={drawer} role="dialog" aria-modal="true" aria-label="Navigation"><Sidebar onClose={() => setMobileOpen(false)} /></div></div>}
      <div className="app-workspace"><Header title={routeTitle(pathname)} onMenu={() => setMobileOpen(true)} navigationOpen={mobileOpen} /><main id="main-content" tabIndex={-1} className="app-content"><Outlet /></main><footer className="workspace-footer"><span>AwareNow</span><span>Awareness operations workspace</span></footer></div>
      {!mustChangePassword && <AiChatWidget />}
    </div>
  );
}
